__turbopack_context__.v({
  "arrowLeft": "styles-module__uGU_8G__arrowLeft",
  "arrowRight": "styles-module__uGU_8G__arrowRight",
  "card": "styles-module__uGU_8G__card",
  "cardTitle": "styles-module__uGU_8G__cardTitle",
  "des": "styles-module__uGU_8G__des",
  "feedBackContainer": "styles-module__uGU_8G__feedBackContainer",
  "listCard": "styles-module__uGU_8G__listCard",
  "top": "styles-module__uGU_8G__top",
});
